/* eslint-disable no-unused-vars */
// needed since color isn't used in the template but appears in the replaced body
import React from "react";
import PropTypes from "prop-types";

/*
 * Yuka v2.0
 * This component corresponds to ``file.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */
const FileIcon = ({ color, size }) => (
  <svg width={size} height={size} viewBox="0 0 18 18">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        fill={color}
        fillRule="evenodd"
        d="M6.56903 0.75L10.5 0.750001C10.6989 0.750001 10.8897 0.829018 11.0303 0.969671L15.5303 5.46967C15.671 5.61032 15.75 5.80109 15.75 6V12.931C15.75 13.5347 15.75 14.033 15.7169 14.4389C15.6824 14.8604 15.6085 15.248 15.423 15.612C15.1354 16.1765 14.6765 16.6354 14.112 16.923C13.748 17.1085 13.3604 17.1824 12.9389 17.2169C12.533 17.25 12.0347 17.25 11.431 17.25H6.56901C5.96529 17.25 5.46702 17.25 5.06113 17.2169C4.63956 17.1824 4.25203 17.1085 3.88803 16.923C3.32354 16.6354 2.8646 16.1765 2.57698 15.612C2.39151 15.248 2.31759 14.8604 2.28315 14.4389C2.24998 14.033 2.24999 13.5347 2.25 12.931V5.06903C2.24999 4.4653 2.24998 3.96703 2.28315 3.56113C2.31759 3.13956 2.39151 2.75203 2.57698 2.38803C2.8646 1.82354 3.32354 1.3646 3.88803 1.07698C4.25203 0.891513 4.63956 0.81759 5.06113 0.783146C5.46703 0.749983 5.9653 0.749991 6.56903 0.75ZM5.18328 2.27816C4.85447 2.30503 4.68631 2.35372 4.56902 2.41349C4.28677 2.5573 4.0573 2.78677 3.91349 3.06902C3.85372 3.18631 3.80503 3.35447 3.77816 3.68328C3.75058 4.02085 3.75 4.45757 3.75 5.1V12.9C3.75 13.5424 3.75058 13.9792 3.77816 14.3167C3.80503 14.6455 3.85372 14.8137 3.91349 14.931C4.0573 15.2132 4.28677 15.4427 4.56902 15.5865C4.68631 15.6463 4.85447 15.695 5.18328 15.7218C5.52085 15.7494 5.95757 15.75 6.6 15.75H11.4C12.0424 15.75 12.4792 15.7494 12.8167 15.7218C13.1455 15.695 13.3137 15.6463 13.431 15.5865C13.7132 15.4427 13.9427 15.2132 14.0865 14.931C14.1463 14.8137 14.195 14.6455 14.2218 14.3167C14.2494 13.9792 14.25 13.5424 14.25 12.9V6.75005L11.6761 6.75006C11.4868 6.75008 11.3024 6.7501 11.1463 6.73734C10.9749 6.72334 10.7726 6.69029 10.569 6.58656C10.2868 6.44275 10.0573 6.21328 9.91349 5.93104C9.80977 5.72747 9.77672 5.52517 9.76271 5.35373C9.74995 5.1976 9.74998 5.01326 9.75 4.82397L9.75 2.25H6.6C5.95757 2.25 5.52085 2.25058 5.18328 2.27816ZM11.25 3.31066L13.1894 5.25005H11.7C11.4776 5.25005 11.3559 5.24947 11.2685 5.24233C11.265 5.24204 11.2617 5.24176 11.2586 5.24147C11.2583 5.23835 11.258 5.23506 11.2577 5.23158C11.2506 5.14414 11.25 5.02245 11.25 4.80006V3.31066ZM5.25 6.75C5.25 6.33579 5.58579 6 6 6H7.5C7.91421 6 8.25 6.33579 8.25 6.75C8.25 7.16421 7.91421 7.5 7.5 7.5H6C5.58579 7.5 5.25 7.16421 5.25 6.75ZM5.25 9.75C5.25 9.33579 5.58579 9 6 9H12C12.4142 9 12.75 9.33579 12.75 9.75C12.75 10.1642 12.4142 10.5 12 10.5H6C5.58579 10.5 5.25 10.1642 5.25 9.75ZM5.25 12.75C5.25 12.3358 5.58579 12 6 12H12C12.4142 12 12.75 12.3358 12.75 12.75C12.75 13.1642 12.4142 13.5 12 13.5H6C5.58579 13.5 5.25 13.1642 5.25 12.75Z"
        transform=""
      />
    </g>
  </svg>
);

FileIcon.propTypes = {
  // all of these can be overriden in CSS as necessary
  color: PropTypes.string,
  size: PropTypes.number,
};

FileIcon.defaultProps = {
  color: "#ffffff",
  size: 16,
};

FileIcon.displayName = "FileIcon";

export default FileIcon;
